<script lang="ts">
    import { createEventDispatcher } from "svelte"
    import Input from "../formComponents/Input.svelte"
    import Select from "../../taskSteps/inputfields/Select.svelte"
    import { onChange } from "../formComponents/helper"
    export let generalDetails: TaskTowing["generalDetails"]

    const dispatch = createEventDispatcher<{
        change: void
        blur: { valueChanged: boolean }
    }>()

    function forwardChange() {
        dispatch("change")
    }

    function forwardBlur(valueChanged: boolean) {
        dispatch("blur", { valueChanged })
    }
</script>

<div class="grid">
    <div
        style="height: 60px;"
        class="col-6"
    >
        <Select
            field="{{
                name: 'damageType',
                label: 'Schadensart',
                widget: 'select',
                pathInDb: 'generalDetails.damageType',
                options: [
                    {
                        value: 'crash',
                        label: 'Unfall',
                    },
                    {
                        value: 'breakdown',
                        label: 'Panne',
                    },
                ],
            }}"
            bind:value="{generalDetails.damageType}"
            on:valueChanged="{forwardChange}"
        />
    </div>
    <div
        style="height: 60px;"
        class="col-6"
    >
        <Select
            field="{{
                name: 'transmissionType',
                label: 'Getriebeart',
                widget: 'select',
                pathInDb: 'generalDetails.transmissionType',
                options: [
                    {
                        value: 'manual',
                        label: 'Manuell',
                    },
                    {
                        value: 'automatic',
                        label: 'Automatisch',
                    },
                ],
            }}"
            bind:value="{generalDetails.transmissionType}"
            on:valueChanged="{forwardChange}"
        />
    </div>
</div>
<div class="grid">
    <div
        style="height: 60px;"
        class="col-6"
    >
        <Select
            field="{{
                name: 'functionality',
                label: 'Rollfähig',
                widget: 'select',
                pathInDb: 'generalDetails.functionality',
                options: [
                    { value: 'yes', label: 'Ja' },
                    { value: 'no', label: 'Nein' },
                ],
            }}"
            bind:value="{generalDetails.functionality}"
            on:valueChanged="{forwardChange}"
        />
    </div>
    <div
        style="height: 60px;"
        class="col-6"
    >
        <Select
            field="{{
                name: 'recoveryNeeded',
                label: 'Bergung notwendig',
                widget: 'select',
                pathInDb: 'generalDetails.recoveryNeeded',
                options: [
                    { value: 'yes', label: 'Ja' },
                    { value: 'no', label: 'Nein' },
                ],
            }}"
            bind:value="{generalDetails.recoveryNeeded}"
            on:valueChanged="{forwardChange}"
        />
    </div>
</div>
<div class="grid">
    <div
        style="height: 60px;"
        class="col-6"
    >
        <Select
            field="{{
                name: 'allWheelDrive',
                label: 'Allrad',
                widget: 'select',
                pathInDb: 'generalDetails.allWheelDrive',
                options: [
                    { value: 'yes', label: 'Ja' },
                    { value: 'no', label: 'Nein' },
                ],
            }}"
            bind:value="{generalDetails.allWheelDrive}"
            on:valueChanged="{forwardChange}"
        />
    </div>
    <div
        style="height: 60px;"
        class="col-6"
    >
        <Select
            field="{{
                name: 'driveType',
                label: 'Antriebsart',
                widget: 'select',
                pathInDb: 'generalDetails.driveType',
                options: [
                    { value: 'petrol', label: 'Benzin' },
                    { value: 'diesel', label: 'Diesel' },
                    { value: 'electric', label: 'Elektro' },
                    { value: 'hybrid', label: 'Hybrid' },
                ],
            }}"
            bind:value="{generalDetails.driveType}"
            on:valueChanged="{forwardChange}"
        />
    </div>
</div>

<div
    style="height: 60px;"
    class="col-6"
>
    <Input
        id="vehicleType"
        placeholder="Fahrzeugtyp"
        onChange="{onChange}"
        bind:value="{generalDetails.vehicleType}"
        onBlur="{(_, valueChanged) => forwardBlur(valueChanged)}"
    />
</div>
<div class="grid">
    <div
        style="height: 60px;"
        class="col-6"
    >
        <Input
            type="text"
            id="contactPersonName"
            placeholder="Ansprechpartner (Vor Ort) Name"
            bind:value="{generalDetails.contactPerson.name}"
            onChange="{onChange}"
            onBlur="{(_, valueChanged) => forwardBlur(valueChanged)}"
        />
    </div>

    <div
        style="height: 60px;"
        class="col-6"
    >
        <Input
            type="text"
            id="contactPersonPhone"
            placeholder="Ansprechpartner (Vor Ort) Telefon"
            bind:value="{generalDetails.contactPerson.phone}"
            onChange="{onChange}"
            onBlur="{(_, valueChanged) => forwardBlur(valueChanged)}"
        />
    </div>
</div>
